<script setup lang="ts">

</script>

<template>
  <v-app class="gradient-background">
    <div>
      <TheNavBar />
      <slot />
      <TheFooter />
    </div>
  </v-app>
</template>

<style scoped>

</style>
